// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #region Responsive Framework */
/* #endregion */
/* #region Content Items */
/* #endregion */
/* #region Color Palette */
/* #region Border Radius */
/* #endregion */
/* #region Typography */
/* #endregion */
/* #region Button */
/* #endregion */
/* #region Z-Index */
/* #endregion */
/*
  The spacing function is a simple utility that takes a multiplier and returns the corresponding 
  spacing value based on the defined spacing step. This allows for easy adjustments to the overall 
  spacing of the app by simply changing the value of \$spacing-step.

  This is made only to mirror the spacing function in the design system.

  - MRA
*/
/*
  The breakpoint mixins are utilities for handling responsive design. They allow you to write media queries 
  in a more readable and maintainable way by using named breakpoints defined in the \$breakpoints map.

  - MRA
*/
/*
  Experimental

  There are now two distinct fluid helpers in this file:

  1. \`fluid-props(\$map, \$breakpoint)\`
     Keeps the existing behavior for a group of properties.
     Static values are emitted first, and inside \`respond-down(\$breakpoint)\`
     each property scales from the provided value down toward the \`sm\`
     breakpoint using the original proportional logic.

  2. \`fluid-prop-range(...)\`
     Handles a single property with three explicit values:
     - a base value, emitted outside any media query
     - a min value, used for scaling down from \`xl\` to \`sm\`
     - a max value, used for scaling up from \`xxl\` and above

     The downscale path is a direct interpolation between the explicit
     min and base values. The upscale path reuses the same proportional
     viewport logic as the original helper, anchored to the base value,
     and clamps the result so it never exceeds the explicit max value.

  - MRA
*/
/*
  Builds a clamp() expression from two explicit values and two explicit
  breakpoints.

  This is the low-level interpolation helper used when both endpoints are
  known, for example when a property should be exactly 24px at \`sm\` and
  exactly 40px at \`xl\`.
*/
/*
  Recreates the original proportional scaling logic used by \`fluid-prop\`.

  Only the upper value is supplied. The lower value is derived from the
  ratio between the provided maximum value and its controlling breakpoint,
  then passed through \`fluid-between()\` for the final clamp() expression.
*/
/*
  Scales upward from a base value using the same proportional viewport logic
  as the original helper, then clamps that growth to an explicit max value.

  The ratio is anchored to the base value and its reference breakpoint.
  In practice this means the property keeps its base value until the viewport
  is large enough for the preferred fluid expression to exceed it, after which
  it grows smoothly until the explicit max value is reached.
*/
/*
  Single-property helper for the three-value case.

  Output behavior:
  - Base value is emitted directly, outside any media query.
  - Inside \`respond-down(\$base-name)\`, the property scales from the explicit
    min value up to the base value.
  - If \`\$max-value\` is provided, inside \`respond-up(\$max-name)\` the property
    scales upward from the base value and is clamped so it never exceeds the
    explicit max value.
  - If \`\$max-value\` is omitted (or \`null\`), no upscale media query is emitted.

  Example:
  @include utils.fluid-prop-range(font-size, 40px, 24px, 56px);

  Example without max:
  @include utils.fluid-prop-range(font-size, 40px, 24px);
*/
/*
  Group-property helper for the original xl-to-sm scaling case.

  Output behavior:
  - Each property in the map is emitted first as a static base value,
    outside any media query.
  - Inside \`respond-down(\$breakpoint)\`, every property in the map is
    recalculated with the original proportional fluid logic so it scales
    down toward the \`sm\` breakpoint.

  This helper is intended for the existing multi-property scenario where a
  component has one shared upper breakpoint and each property should shrink
  proportionally beneath it.

  Examples:
  @include utils.fluid-props((margin-top: 64px, margin-left: 52px));
  @include utils.fluid-props((margin-top: 64px), \$breakpoint: lg);
*/
.favorites__m536v {
  display: flex;
  height: 100vh;
}
.browser-mode .favorites__m536v {
  max-width: 1920px;
  min-width: 880px;
}
.favorites__m536v {
  padding-top: 122px;
}
.browser-mode .favorites__m536v {
  padding-top: calc(122px * 0.65);
}
.favorites__m536v {
  padding-left: 88px;
}
.browser-mode .favorites__m536v {
  padding-left: calc(88px * 0.65);
}
.favorites__m536v {
  padding-right: 88px;
}
.browser-mode .favorites__m536v {
  padding-right: calc(88px * 0.65);
}
.favorites__m536v {
  padding-bottom: 88px;
}
.browser-mode .favorites__m536v {
  padding-bottom: calc(88px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites__m536v {
    padding-top: clamp(calc(calc(122px * 0.65) * 0.4583333333), calc(calc(122px * 0.65) * 0.4583333333) + (calc(122px * 0.65) - calc(calc(122px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(122px * 0.65));
  }
  .browser-mode .favorites__m536v {
    padding-left: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .favorites__m536v {
    padding-right: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .favorites__m536v {
    padding-bottom: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
}
:not(.browser-mode) .favorites__m536v {
  padding-bottom: 0;
}

.favorites-dialog-container__HtLjF {
  overflow: auto;
}

.favorites-home-layout__Lk0Dc {
  flex-shrink: 0;
  width: 580px;
}
.browser-mode .favorites-home-layout__Lk0Dc {
  width: calc(580px * 0.65);
}
.favorites-home-layout__Lk0Dc {
  margin-right: 88px;
}
.browser-mode .favorites-home-layout__Lk0Dc {
  margin-right: calc(88px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-layout__Lk0Dc {
    width: clamp(calc(calc(580px * 0.65) * 0.4583333333), calc(calc(580px * 0.65) * 0.4583333333) + (calc(580px * 0.65) - calc(calc(580px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(580px * 0.65));
  }
  .browser-mode .favorites-home-layout__Lk0Dc {
    margin-right: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
}

.favorites-home-root--title__AHYpy {
  width: 100%;
  overflow-wrap: break-word;
  margin-bottom: 32px;
}
.browser-mode .favorites-home-root--title__AHYpy {
  margin-bottom: calc(32px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-root--title__AHYpy {
    margin-bottom: clamp(calc(20.8px * 0.65), calc(20.8px * 0.65) + (calc(32px * 0.65) - calc(20.8px * 0.65)) * (100vw - 880px) / 1040px, calc(32px * 0.65));
  }
}
.favorites-home-root--list__cCN8R {
  height: 550px;
}
.browser-mode .favorites-home-root--list__cCN8R {
  height: calc(550px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-root--list__cCN8R {
    height: clamp(calc(357.5px * 0.65), calc(357.5px * 0.65) + (calc(550px * 0.65) - calc(357.5px * 0.65)) * (100vw - 880px) / 1040px, calc(550px * 0.65));
  }
}
.favorites-home-root--row__DDeMS {
  display: flex;
  flex-direction: row;
}
.favorites-home-root--item__kHNK6 {
  width: 379px;
}
.browser-mode .favorites-home-root--item__kHNK6 {
  width: calc(379px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-root--item__kHNK6 {
    width: clamp(calc(calc(379px * 0.65) * 0.4583333333), calc(calc(379px * 0.65) * 0.4583333333) + (calc(379px * 0.65) - calc(calc(379px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(379px * 0.65));
  }
}
.favorites-home-root--item__kHNK6 {
  flex: none;
}
.favorites-home-root--actions__KQ5bC {
  display: flex;
  flex-direction: row;
}
.favorites-home-root--actions__KQ5bC .favorites-home-root--btn-wrap__XLvf5 {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: visible;
  margin-left: 32px;
}
.browser-mode .favorites-home-root--actions__KQ5bC .favorites-home-root--btn-wrap__XLvf5 {
  margin-left: calc(32px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-root--actions__KQ5bC .favorites-home-root--btn-wrap__XLvf5 {
    margin-left: clamp(calc(20.8px * 0.65), calc(20.8px * 0.65) + (calc(32px * 0.65) - calc(20.8px * 0.65)) * (100vw - 880px) / 1040px, calc(32px * 0.65));
  }
}
.favorites-home-root--actions__KQ5bC .favorites-home-root--btn-wrap__XLvf5 {
  width: 72px;
}
.browser-mode .favorites-home-root--actions__KQ5bC .favorites-home-root--btn-wrap__XLvf5 {
  width: calc(72px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-root--actions__KQ5bC .favorites-home-root--btn-wrap__XLvf5 {
    width: clamp(calc(46.8px * 0.65), calc(46.8px * 0.65) + (calc(72px * 0.65) - calc(46.8px * 0.65)) * (100vw - 880px) / 1040px, calc(72px * 0.65));
  }
}
.favorites-home-root--actions__KQ5bC .favorites-home-root--btn-wrap__XLvf5 {
  height: 72px;
}
.browser-mode .favorites-home-root--actions__KQ5bC .favorites-home-root--btn-wrap__XLvf5 {
  height: calc(72px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-root--actions__KQ5bC .favorites-home-root--btn-wrap__XLvf5 {
    height: clamp(calc(46.8px * 0.65), calc(46.8px * 0.65) + (calc(72px * 0.65) - calc(46.8px * 0.65)) * (100vw - 880px) / 1040px, calc(72px * 0.65));
  }
}
.favorites-home-root--actions__KQ5bC .favorites-home-root--btn__f6FAx {
  padding: 0;
  min-width: 72px;
}
.browser-mode .favorites-home-root--actions__KQ5bC .favorites-home-root--btn__f6FAx {
  min-width: calc(72px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-root--actions__KQ5bC .favorites-home-root--btn__f6FAx {
    min-width: clamp(calc(46.8px * 0.65), calc(46.8px * 0.65) + (calc(72px * 0.65) - calc(46.8px * 0.65)) * (100vw - 880px) / 1040px, calc(72px * 0.65));
  }
}
.favorites-home-root--actions__KQ5bC .favorites-home-root--btn__f6FAx {
  min-height: 72px;
}
.browser-mode .favorites-home-root--actions__KQ5bC .favorites-home-root--btn__f6FAx {
  min-height: calc(72px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-root--actions__KQ5bC .favorites-home-root--btn__f6FAx {
    min-height: clamp(calc(46.8px * 0.65), calc(46.8px * 0.65) + (calc(72px * 0.65) - calc(46.8px * 0.65)) * (100vw - 880px) / 1040px, calc(72px * 0.65));
  }
}
.favorites-home-root--actions__KQ5bC .favorites-home-root--btn__f6FAx {
  margin-bottom: 4px;
}
.browser-mode .favorites-home-root--actions__KQ5bC .favorites-home-root--btn__f6FAx {
  margin-bottom: calc(4px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-root--actions__KQ5bC .favorites-home-root--btn__f6FAx {
    margin-bottom: clamp(calc(2.6px * 0.65), calc(2.6px * 0.65) + (calc(4px * 0.65) - calc(2.6px * 0.65)) * (100vw - 880px) / 1040px, calc(4px * 0.65));
  }
}
.favorites-home-root--actions__KQ5bC .favorites-home-root--btn-label__n5Tqm {
  display: block;
  width: max-content;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
.favorites-home-root--create__cBiNL {
  margin-top: 24px;
  max-width: 456px;
  width: 100%;
}
.favorites-home-root--create-btn__Gs8OX, .favorites-home-root--back-btn__NPeXk {
  max-width: 406px;
  width: 100%;
}
.favorites-home-root--back-btn__NPeXk {
  margin-top: 24px;
}

.favorites-home-channels-layout__eKqzO {
  min-width: 0;
  max-width: 1132px;
}
.browser-mode .favorites-home-channels-layout__eKqzO {
  max-width: calc(1132px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-channels-layout__eKqzO {
    max-width: clamp(calc(calc(1132px * 0.65) * 0.4583333333), calc(calc(1132px * 0.65) * 0.4583333333) + (calc(1132px * 0.65) - calc(calc(1132px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(1132px * 0.65));
  }
}

.favorites-home-channels-root--image__WPsaU {
  width: 100px;
}
.browser-mode .favorites-home-channels-root--image__WPsaU {
  width: calc(100px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-channels-root--image__WPsaU {
    width: clamp(calc(85px * 0.65), calc(85px * 0.65) + (calc(100px * 0.65) - calc(85px * 0.65)) * (100vw - 880px) / 1040px, calc(100px * 0.65));
  }
}
.favorites-home-channels-root--image__WPsaU {
  height: 65px;
}
.browser-mode .favorites-home-channels-root--image__WPsaU {
  height: calc(65px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-channels-root--image__WPsaU {
    height: clamp(calc(55.25px * 0.65), calc(55.25px * 0.65) + (calc(65px * 0.65) - calc(55.25px * 0.65)) * (100vw - 880px) / 1040px, calc(65px * 0.65));
  }
}
.favorites-home-channels-root--image__WPsaU {
  border-radius: 4px;
  margin-bottom: 16px;
}
.browser-mode .favorites-home-channels-root--image__WPsaU {
  margin-bottom: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-channels-root--image__WPsaU {
    margin-bottom: clamp(calc(13.6px * 0.65), calc(13.6px * 0.65) + (calc(16px * 0.65) - calc(13.6px * 0.65)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.favorites-home-channels-root--image__WPsaU {
  margin-right: 16px;
}
.browser-mode .favorites-home-channels-root--image__WPsaU {
  margin-right: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-home-channels-root--image__WPsaU {
    margin-right: clamp(calc(13.6px * 0.65), calc(13.6px * 0.65) + (calc(16px * 0.65) - calc(13.6px * 0.65)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.favorites-home-channels-root--desc__ubj9f {
  font-weight: bold;
  margin-top: 16px;
}

/**/
.favorites-edit-layout__c_75X {
  width: 100%;
}
.favorites-edit-layout--hidden__qO45A {
  visibility: hidden;
  width: 0;
  overflow: hidden;
}

.favorites-edit-root--content__ANPhS {
  display: grid;
  grid-template-columns: max-content minmax(0, max-content) auto;
  grid-template-rows: auto minmax(0, 1fr);
  height: calc(100% - 84px);
  align-items: flex-start;
  padding-top: 40px;
}
.favorites-edit-root--logo__L_2u6 {
  border-radius: 4px;
  height: 49px;
}
.browser-mode .favorites-edit-root--logo__L_2u6 {
  height: calc(49px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--logo__L_2u6 {
    height: clamp(calc(41.65px * 0.65), calc(41.65px * 0.65) + (calc(49px * 0.65) - calc(41.65px * 0.65)) * (100vw - 880px) / 1040px, calc(49px * 0.65));
  }
}
.favorites-edit-root--logo__L_2u6 {
  width: 75px;
}
.browser-mode .favorites-edit-root--logo__L_2u6 {
  width: calc(75px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--logo__L_2u6 {
    width: clamp(calc(63.75px * 0.65), calc(63.75px * 0.65) + (calc(75px * 0.65) - calc(63.75px * 0.65)) * (100vw - 880px) / 1040px, calc(75px * 0.65));
  }
}
.favorites-edit-root--logo__L_2u6 {
  border-radius: 4px;
}
.browser-mode .favorites-edit-root--logo__L_2u6 {
  border-radius: calc(4px * 0.65);
}
.favorites-edit-root--logo__L_2u6 {
  margin-right: 16px;
}
.browser-mode .favorites-edit-root--logo__L_2u6 {
  margin-right: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--logo__L_2u6 {
    border-radius: clamp(calc(calc(4px * 0.65) * 0.4583333333), calc(calc(4px * 0.65) * 0.4583333333) + (calc(4px * 0.65) - calc(calc(4px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(4px * 0.65));
  }
  .browser-mode .favorites-edit-root--logo__L_2u6 {
    margin-right: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.favorites-edit-root--channels-tv__Q81Oj {
  overflow: hidden;
  grid-column: 1;
  grid-row: 2;
  height: 100%;
  width: 520px;
}
.browser-mode .favorites-edit-root--channels-tv__Q81Oj {
  width: calc(520px * 0.65);
}
.favorites-edit-root--channels-tv__Q81Oj {
  margin-right: 122px;
}
.browser-mode .favorites-edit-root--channels-tv__Q81Oj {
  margin-right: calc(122px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--channels-tv__Q81Oj {
    width: clamp(calc(calc(520px * 0.65) * 0.4583333333), calc(calc(520px * 0.65) * 0.4583333333) + (calc(520px * 0.65) - calc(calc(520px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(520px * 0.65));
  }
  .browser-mode .favorites-edit-root--channels-tv__Q81Oj {
    margin-right: clamp(calc(calc(122px * 0.65) * 0.4583333333), calc(calc(122px * 0.65) * 0.4583333333) + (calc(122px * 0.65) - calc(calc(122px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(122px * 0.65));
  }
}
.favorites-edit-root--channels-browser__x0vSY {
  overflow: hidden;
  grid-column: 1;
  grid-row: 2;
  width: 520px;
}
.browser-mode .favorites-edit-root--channels-browser__x0vSY {
  width: calc(520px * 0.65);
}
.favorites-edit-root--channels-browser__x0vSY {
  margin-right: 122px;
}
.browser-mode .favorites-edit-root--channels-browser__x0vSY {
  margin-right: calc(122px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--channels-browser__x0vSY {
    width: clamp(calc(calc(520px * 0.65) * 0.4583333333), calc(calc(520px * 0.65) * 0.4583333333) + (calc(520px * 0.65) - calc(calc(520px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(520px * 0.65));
  }
  .browser-mode .favorites-edit-root--channels-browser__x0vSY {
    margin-right: clamp(calc(calc(122px * 0.65) * 0.4583333333), calc(calc(122px * 0.65) * 0.4583333333) + (calc(122px * 0.65) - calc(calc(122px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(122px * 0.65));
  }
}
.favorites-edit-root--menu__hrerk {
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  grid-column: 3;
  grid-row: 2;
  margin-left: auto;
  margin-top: 125px;
}
.browser-mode .favorites-edit-root--menu__hrerk {
  margin-top: calc(125px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--menu__hrerk {
    margin-top: clamp(calc(calc(125px * 0.65) * 0.4583333333), calc(calc(125px * 0.65) * 0.4583333333) + (calc(125px * 0.65) - calc(calc(125px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(125px * 0.65));
  }
}
.favorites-edit-root--menu-btn__Lvg76 {
  width: 188px;
}
.browser-mode .favorites-edit-root--menu-btn__Lvg76 {
  width: calc(188px * 0.65);
}
.favorites-edit-root--menu-btn__Lvg76 {
  border-radius: 28px;
}
.browser-mode .favorites-edit-root--menu-btn__Lvg76 {
  border-radius: calc(28px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--menu-btn__Lvg76 {
    width: clamp(calc(calc(188px * 0.65) * 0.4583333333), calc(calc(188px * 0.65) * 0.4583333333) + (calc(188px * 0.65) - calc(calc(188px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(188px * 0.65));
  }
  .browser-mode .favorites-edit-root--menu-btn__Lvg76 {
    border-radius: clamp(calc(calc(28px * 0.65) * 0.4583333333), calc(calc(28px * 0.65) * 0.4583333333) + (calc(28px * 0.65) - calc(calc(28px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(28px * 0.65));
  }
}
.favorites-edit-root--menu-btn__Lvg76:not(:last-of-type) {
  margin-bottom: 32px;
}
.browser-mode .favorites-edit-root--menu-btn__Lvg76:not(:last-of-type) {
  margin-bottom: calc(32px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--menu-btn__Lvg76:not(:last-of-type) {
    margin-bottom: clamp(calc(calc(32px * 0.65) * 0.4583333333), calc(calc(32px * 0.65) * 0.4583333333) + (calc(32px * 0.65) - calc(calc(32px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(32px * 0.65));
  }
}
.favorites-edit-root--empty__UXrOI {
  display: flex;
  flex-direction: column;
  grid-column: 2;
  grid-row: 1/span 2;
  margin-top: 40px;
}
.favorites-edit-root--empty-title__b27_E {
  margin-left: 64px;
}
.browser-mode .favorites-edit-root--empty-title__b27_E {
  margin-left: calc(64px * 0.65);
}
.favorites-edit-root--empty-title__b27_E {
  margin-bottom: 16px;
}
.browser-mode .favorites-edit-root--empty-title__b27_E {
  margin-bottom: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--empty-title__b27_E {
    margin-left: clamp(calc(calc(64px * 0.65) * 0.4583333333), calc(calc(64px * 0.65) * 0.4583333333) + (calc(64px * 0.65) - calc(calc(64px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(64px * 0.65));
  }
  .browser-mode .favorites-edit-root--empty-title__b27_E {
    margin-bottom: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.favorites-edit-root--empty-secondary-title__wv9nc {
  margin-left: 64px;
}
.browser-mode .favorites-edit-root--empty-secondary-title__wv9nc {
  margin-left: calc(64px * 0.65);
}
.favorites-edit-root--empty-secondary-title__wv9nc {
  margin-bottom: 16px;
}
.browser-mode .favorites-edit-root--empty-secondary-title__wv9nc {
  margin-bottom: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--empty-secondary-title__wv9nc {
    margin-left: clamp(calc(calc(64px * 0.65) * 0.4583333333), calc(calc(64px * 0.65) * 0.4583333333) + (calc(64px * 0.65) - calc(calc(64px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(64px * 0.65));
  }
  .browser-mode .favorites-edit-root--empty-secondary-title__wv9nc {
    margin-bottom: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.favorites-edit-root--selected__CVO4v {
  display: contents;
  min-width: 0;
}
.favorites-edit-root--selected-header__eVuyy {
  grid-column: 2;
  grid-row: 1;
}
.favorites-edit-root--selected-title__lrale {
  margin-left: 64px;
}
.browser-mode .favorites-edit-root--selected-title__lrale {
  margin-left: calc(64px * 0.65);
}
.favorites-edit-root--selected-title__lrale {
  margin-bottom: 44px;
}
.browser-mode .favorites-edit-root--selected-title__lrale {
  margin-bottom: calc(44px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--selected-title__lrale {
    margin-left: clamp(calc(calc(64px * 0.65) * 0.4583333333), calc(calc(64px * 0.65) * 0.4583333333) + (calc(64px * 0.65) - calc(calc(64px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(64px * 0.65));
  }
  .browser-mode .favorites-edit-root--selected-title__lrale {
    margin-bottom: clamp(calc(calc(44px * 0.65) * 0.4583333333), calc(calc(44px * 0.65) * 0.4583333333) + (calc(44px * 0.65) - calc(calc(44px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(44px * 0.65));
  }
}
.favorites-edit-root--selected-secondary-title__UUHRw {
  margin-left: 64px;
}
.browser-mode .favorites-edit-root--selected-secondary-title__UUHRw {
  margin-left: calc(64px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--selected-secondary-title__UUHRw {
    margin-left: clamp(calc(calc(64px * 0.65) * 0.4583333333), calc(calc(64px * 0.65) * 0.4583333333) + (calc(64px * 0.65) - calc(calc(64px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(64px * 0.65));
  }
}
.favorites-edit-root--list-tv__DoIXH {
  overflow: hidden;
  grid-column: 2;
  grid-row: 2;
  padding-bottom: 12px;
  height: 100%;
}
.favorites-edit-root--list-browser__YSRAH {
  grid-column: 2;
  grid-row: 2;
  padding-bottom: 12px;
}
.favorites-edit-root--draggable__BVswv:not(.favorites-edit-root--dragging__TERH1) {
  border: 4px dashed transparent;
}
.favorites-edit-root--dragging__TERH1 {
  border: 4px dashed #8370f1;
}
.favorites-edit-root--row__WTF4l {
  display: flex;
  flex-direction: row;
  margin-bottom: 12px;
}
.browser-mode .favorites-edit-root--row__WTF4l {
  margin-bottom: calc(12px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--row__WTF4l {
    margin-bottom: clamp(calc(calc(12px * 0.65) * 0.4583333333), calc(calc(12px * 0.65) * 0.4583333333) + (calc(12px * 0.65) - calc(calc(12px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(12px * 0.65));
  }
}
.favorites-edit-root--num__iYtea {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 48px;
}
.browser-mode .favorites-edit-root--num__iYtea {
  width: calc(48px * 0.65);
}
.favorites-edit-root--num__iYtea {
  margin-right: 16px;
}
.browser-mode .favorites-edit-root--num__iYtea {
  margin-right: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--num__iYtea {
    width: clamp(calc(calc(48px * 0.65) * 0.4583333333), calc(calc(48px * 0.65) * 0.4583333333) + (calc(48px * 0.65) - calc(calc(48px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(48px * 0.65));
  }
  .browser-mode .favorites-edit-root--num__iYtea {
    margin-right: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.favorites-edit-root--item__OPnqT {
  overflow: hidden;
  width: 520px;
}
.browser-mode .favorites-edit-root--item__OPnqT {
  width: calc(520px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-edit-root--item__OPnqT {
    width: clamp(calc(calc(520px * 0.65) * 0.4583333333), calc(calc(520px * 0.65) * 0.4583333333) + (calc(520px * 0.65) - calc(calc(520px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(520px * 0.65));
  }
}
.favorites-edit-root--order__luVYP {
  display: flex;
  flex-direction: row;
}
.favorites-edit-root--order__luVYP .favorites-edit-root--order-btn-wrap__kpdQG {
  margin-left: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: visible;
  width: 90px;
  height: 72px;
}
.favorites-edit-root--order__luVYP .favorites-edit-root--order-btn-wrap-right__hy27I {
  margin-left: 8px;
}
.favorites-edit-root--order__luVYP .favorites-edit-root--order-btn__ZO6eU {
  min-width: 72px;
  min-height: 72px;
  padding: 0;
  margin-bottom: 4px;
}

.favorites-save-layout__sAQwt,
.favorites-delete-layout__WgyTL {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.favorites-save-root--title__KMesw,
.favorites-delete-root--title__G9IEq {
  width: 100%;
  text-align: center;
  margin-bottom: 40px;
}
.browser-mode .favorites-save-root--title__KMesw,
.browser-mode .favorites-delete-root--title__G9IEq {
  margin-bottom: calc(40px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-save-root--title__KMesw,
  .browser-mode .favorites-delete-root--title__G9IEq {
    margin-bottom: clamp(calc(26px * 0.65), calc(26px * 0.65) + (calc(40px * 0.65) - calc(26px * 0.65)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
}
.favorites-save-root--name__uBSpI,
.favorites-delete-root--name__LyfZu {
  margin-bottom: 80px;
}
.browser-mode .favorites-save-root--name__uBSpI,
.browser-mode .favorites-delete-root--name__LyfZu {
  margin-bottom: calc(80px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-save-root--name__uBSpI,
  .browser-mode .favorites-delete-root--name__LyfZu {
    margin-bottom: clamp(calc(52px * 0.65), calc(52px * 0.65) + (calc(80px * 0.65) - calc(52px * 0.65)) * (100vw - 880px) / 1040px, calc(80px * 0.65));
  }
}
.favorites-save-root--button__UotRl,
.favorites-delete-root--button__K4WAY {
  width: 406px;
}
.browser-mode .favorites-save-root--button__UotRl,
.browser-mode .favorites-delete-root--button__K4WAY {
  width: calc(406px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-save-root--button__UotRl,
  .browser-mode .favorites-delete-root--button__K4WAY {
    width: clamp(calc(calc(406px * 0.65) * 0.4583333333), calc(calc(406px * 0.65) * 0.4583333333) + (calc(406px * 0.65) - calc(calc(406px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(406px * 0.65));
  }
}
.favorites-save-root--button__UotRl:not(:last-of-type),
.favorites-delete-root--button__K4WAY:not(:last-of-type) {
  margin-bottom: 32px;
}

.favorites-title-layout__SQUW7 {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 675px;
  width: 100%;
  box-sizing: content-box;
  padding-left: 88px;
}
.browser-mode .favorites-title-layout__SQUW7 {
  padding-left: calc(88px * 0.65);
}
.favorites-title-layout__SQUW7 {
  padding-right: 88px;
}
.browser-mode .favorites-title-layout__SQUW7 {
  padding-right: calc(88px * 0.65);
}
.favorites-title-layout__SQUW7 {
  padding-bottom: 88px;
}
.browser-mode .favorites-title-layout__SQUW7 {
  padding-bottom: calc(88px * 0.65);
}
.favorites-title-layout__SQUW7 {
  padding-top: 88px;
}
.browser-mode .favorites-title-layout__SQUW7 {
  padding-top: calc(88px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-title-layout__SQUW7 {
    padding-left: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .favorites-title-layout__SQUW7 {
    padding-right: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .favorites-title-layout__SQUW7 {
    padding-bottom: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .favorites-title-layout__SQUW7 {
    padding-top: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
}

.favorites-title-root--header__AJaIh {
  width: 100%;
  text-align: center;
  margin-bottom: 48px;
}
.browser-mode .favorites-title-root--header__AJaIh {
  margin-bottom: calc(48px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-title-root--header__AJaIh {
    margin-bottom: clamp(calc(calc(48px * 0.65) * 0.4583333333), calc(calc(48px * 0.65) * 0.4583333333) + (calc(48px * 0.65) - calc(calc(48px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(48px * 0.65));
  }
}
.favorites-title-root--input__Y9V9u {
  width: 100%;
  margin-bottom: 40px;
}
.browser-mode .favorites-title-root--input__Y9V9u {
  margin-bottom: calc(40px * 0.65);
}
.favorites-title-root--input__Y9V9u {
  height: 68px;
}
.browser-mode .favorites-title-root--input__Y9V9u {
  height: calc(68px * 0.65);
}
.favorites-title-root--input__Y9V9u {
  min-height: 68px;
}
.browser-mode .favorites-title-root--input__Y9V9u {
  min-height: calc(68px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-title-root--input__Y9V9u {
    margin-bottom: clamp(calc(calc(40px * 0.65) * 0.4583333333), calc(calc(40px * 0.65) * 0.4583333333) + (calc(40px * 0.65) - calc(calc(40px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
  .browser-mode .favorites-title-root--input__Y9V9u {
    height: clamp(calc(calc(68px * 0.65) * 0.4583333333), calc(calc(68px * 0.65) * 0.4583333333) + (calc(68px * 0.65) - calc(calc(68px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(68px * 0.65));
  }
  .browser-mode .favorites-title-root--input__Y9V9u {
    min-height: clamp(calc(calc(68px * 0.65) * 0.4583333333), calc(calc(68px * 0.65) * 0.4583333333) + (calc(68px * 0.65) - calc(calc(68px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(68px * 0.65));
  }
}
.favorites-title-root--error__TBhfz {
  color: #ffdb38;
}
.favorites-title-root--button__KSFLT {
  width: 406px;
}
.browser-mode .favorites-title-root--button__KSFLT {
  width: calc(406px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .favorites-title-root--button__KSFLT {
    width: clamp(calc(calc(406px * 0.65) * 0.4583333333), calc(calc(406px * 0.65) * 0.4583333333) + (calc(406px * 0.65) - calc(calc(406px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(406px * 0.65));
  }
}
.favorites-title-root--button__KSFLT:not(:last-of-type) {
  margin-bottom: 32px;
  margin-top: 40px;
}`, "",{"version":3,"sources":["webpack://./src/scaffold/styles/variables.scss","webpack://./src/scaffold/styles/utilities.scss","webpack://./src/components/favorites/favorites.module.scss"],"names":[],"mappings":"AAOA,iCAAA;AAeA,eAAA;AAUA,0BAAA;AAqCA,eAAA;AAEA,0BAAA;AA+EA,0BAAA;AAMA,eAAA;AAEA,uBAAA;AA+EA,eAAA;AAEA,mBAAA;AAqBA,eAAA;AAEA,oBAAA;AAOA,eAAA;ACzPA;;;;;;;;CAAA;AAcA;;;;;CAAA;AAiCA;;;;;;;;;;;;;;;;;;;;;;;CAAA;AAyBA;;;;;;;CAAA;AAyCA;;;;;;CAAA;AA8BA;;;;;;;;CAAA;AAwCA;;;;;;;;;;;;;;;;;CAAA;AAmDA;;;;;;;;;;;;;;;;;CAAA;AC3PA;EACE,aAAA;EACA,aAAA;AA8GF;AA5GE;EACE,iBFKY;EEJZ,gBAAA;AA8GJ;AApHA;ED+QI,kBCrQA;AA6GJ;AD0JI;EACE,+BAAA;ACxJN;AA1HA;ED+QI,kBCrQA;AAmHJ;ADoJI;EACE,+BAAA;AClJN;AAhIA;ED+QI,mBCrQA;AAyHJ;AD8II;EACE,gCAAA;AC5IN;AAtIA;ED+QI,oBCrQA;AA+HJ;ADwII;EACE,iCAAA;ACtIN;ADvFE;EAoOI;IACE,oNAAA;EC1IN;EDyII;IACE,gNAAA;ECvIN;EDsII;IACE,iNAAA;ECpIN;EDmII;IACE,kNAAA;ECjIN;AACF;AAxIE;EACE,iBAAA;AA0IJ;;AAtIA;EACE,cAAA;AAyIF;;AAtIA;EACE,cAAA;EDmPE,YCjPA;AAwIJ;AD2GI;EACE,yBAAA;ACzGN;AA9IA;EDoPI,kBCjPA;AA8IJ;ADqGI;EACE,+BAAA;ACnGN;AD1HE;EAoOI;IACE,8MAAA;ECvGN;EDsGI;IACE,gNAAA;ECpGN;AACF;;AAjJE;EACE,WAAA;EACA,yBAAA;EDiMF,mBChMiD;AAoJnD;AD+CE;EACE,gCARmB;ACrCvB;AD3IE;EAuLA;IAII,wJAAA;EC5CJ;AACF;AAzJE;ED6LA,aC5L0C;AA2J5C;ADoCE;EACE,0BARmB;AC1BvB;ADtJE;EAuLA;IAII,sJAAA;ECjCJ;AACF;AAhKE;EACE,aAAA;EACA,mBAAA;AAkKJ;AA/JE;ED0NE,YCxNE;AAgKN;AD0DI;EACE,yBAAA;ACxDN;ADrKE;EAoOI;IACE,8MAAA;EC5DN;AACF;AA1KE;EAME,UAAA;AAuKJ;AApKE;EACE,aAAA;EACA,mBAAA;AAsKJ;AApKI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EDmKJ,iBCjKiD;AAqKnD;ADDE;EACE,8BARmB;ACWvB;AD3LE;EAuLA;IAII,sJAAA;ECIJ;AACF;AAnLI;EDuKF,WDMc;AEShB;ADZE;EACE,wBARmB;ACsBvB;ADtME;EAuLA;IAII,gJAAA;ECeJ;AACF;AA9LI;EDuKF,YDMc;AEoBhB;ADvBE;EACE,yBARmB;ACiCvB;ADjNE;EAuLA;IAII,iJAAA;EC0BJ;AACF;AA9LI;EACE,UAAA;ED2JJ,eDMc;AEgChB;ADnCE;EACE,4BARmB;AC6CvB;AD7NE;EAuLA;IAII,oJAAA;ECsCJ;AACF;AA1MI;ED4JF,gBDMc;AE2ChB;AD9CE;EACE,6BARmB;ACwDvB;ADxOE;EAuLA;IAII,qJAAA;ECiDJ;AACF;AArNI;ED4JF,kBCvJmD;AAmNrD;ADzDE;EACE,+BARmB;ACmEvB;ADnPE;EAuLA;IAII,mJAAA;EC4DJ;AACF;AAxNI;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA0NN;AAtNE;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;AAwNJ;AArNE;EAEE,gBAAA;EACA,WAAA;AAsNJ;AAnNE;EACE,gBAAA;AAqNJ;;AAjNA;EACE,YAAA;ED+JE,iBC7JA;AAmNJ;ADpDI;EACE,8BAAA;ACsDN;ADnRE;EAoOI;IACE,uNAAA;ECkDN;AACF;;AApNE;EDgHA,YC/GyC;AAuN3C;ADrGE;EACE,yBARmB;AC+GvB;AD/RE;EAuLA;IAII,4IAAA;ECwGJ;AACF;AAhOE;EDgHA,YC9G0C;AAiO5C;ADhHE;EACE,yBARmB;AC0HvB;AD1SE;EAuLA;IAII,oJAAA;ECmHJ;AACF;AA3OE;EAGE,kBFyBe;ECoFjB,mBC5GiD;AA2OnD;AD5HE;EACE,gCARmB;ACsIvB;ADtTE;EAuLA;IAII,wJAAA;EC+HJ;AACF;AAvPE;EDgHA,kBC3GgD;AAqPlD;ADvIE;EACE,+BARmB;ACiJvB;ADjUE;EAuLA;IAII,uJAAA;EC0IJ;AACF;AA1PE;EACE,iBAAA;EACA,gBAAA;AA4PJ;;AAxPA,GAAA;AACA;EACE,WAAA;AA2PF;AAzPE;EACE,kBAAA;EACA,QAAA;EACA,gBAAA;AA2PJ;;AAtPE;EACE,aAAA;EACA,8DAAA;EACA,uCAAA;EACA,yBAAA;EACA,uBAAA;EACA,iBAAA;AAyPJ;AAtPE;EACE,kBFRe;ECoFjB,YC1E0C;AAuP5C;AD1KE;EACE,yBARmB;ACoLvB;ADpWE;EAuLA;IAII,oJAAA;EC6KJ;AACF;AAlQE;ED6EA,WCzEyC;AAiQ3C;ADrLE;EACE,wBARmB;AC+LvB;AD/WE;EAuLA;IAII,mJAAA;ECwLJ;AACF;AA7QE;EDmHE,kBC5GE;AAyQN;AD3JI;EACE,+BAAA;AC6JN;AAnRE;EDmHE,kBC5GE;AA+QN;ADjKI;EACE,+BAAA;ACmKN;ADhYE;EAoOI;IACE,4MAAA;EC+JN;EDhKI;IACE,gNAAA;ECkKN;AACF;AAnRE;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EDiGA,YC/FE;AAoRN;ADnLI;EACE,yBAAA;ACqLN;AA7RE;EDqGE,mBC/FE;AA0RN;ADzLI;EACE,gCAAA;AC2LN;ADxZE;EAoOI;IACE,8MAAA;ECuLN;EDxLI;IACE,qNAAA;EC0LN;AACF;AA9RE;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EDqFA,YCnFE;AA+RN;AD1MI;EACE,yBAAA;AC4MN;AAvSE;EDwFE,mBCnFE;AAqSN;ADhNI;EACE,gCAAA;ACkNN;AD/aE;EAoOI;IACE,8MAAA;EC8MN;ED/MI;IACE,qNAAA;ECiNN;AACF;AAzSE;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EDqEA,iBClEE;AAySN;ADrOI;EACE,8BAAA;ACuON;ADpcE;EAoOI;IACE,mNAAA;ECmON;AACF;AA3SE;ED4DE,YC1DE;AA4SN;ADhPI;EACE,yBAAA;ACkPN;AAjTE;ED4DE,mBC1DE;AAkTN;ADtPI;EACE,gCAAA;ACwPN;ADrdE;EAoOI;IACE,8MAAA;ECoPN;EDrPI;IACE,iNAAA;ECuPN;AACF;AAvTI;EDoDA,mBClDI;AAwTR;ADpQI;EACE,gCAAA;ACsQN;ADneE;EAoOI;IACE,iNAAA;ECkQN;AACF;AAzTE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA2TJ;AAxTE;EDmCE,iBCjCE;AAyTN;ADtRI;EACE,8BAAA;ACwRN;AA9TE;EDmCE,mBCjCE;AA+TN;AD5RI;EACE,gCAAA;AC8RN;AD3fE;EAoOI;IACE,+MAAA;EC0RN;ED3RI;IACE,iNAAA;EC6RN;AACF;AAnUE;ED0BE,iBCxBE;AAoUN;AD1SI;EACE,8BAAA;AC4SN;AAzUE;ED0BE,mBCxBE;AA0UN;ADhTI;EACE,gCAAA;ACkTN;AD/gBE;EAoOI;IACE,+MAAA;EC8SN;ED/SI;IACE,iNAAA;ECiTN;AACF;AA9UE;EACE,iBAAA;EACA,YAAA;AAgVJ;AA7UE;EACE,cAAA;EACA,WAAA;AA+UJ;AA5UE;EDOE,iBCLE;AA6UN;ADtUI;EACE,8BAAA;ACwUN;AAlVE;EDOE,mBCLE;AAmVN;AD5UI;EACE,gCAAA;AC8UN;AD3iBE;EAoOI;IACE,+MAAA;EC0UN;ED3UI;IACE,iNAAA;EC6UN;AACF;AAxVE;EDDE,iBCGE;AAyVN;AD1VI;EACE,8BAAA;AC4VN;ADzjBE;EAoOI;IACE,+MAAA;ECwVN;AACF;AA3VE;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;AA6VJ;AA1VE;EACE,cAAA;EACA,WAAA;EACA,oBAAA;AA4VJ;AAzVE;EACE,8BAAA;AA2VJ;AAxVE;EACE,0BAAA;AA0VJ;AAvVE;EACE,aAAA;EACA,mBAAA;EDjCA,mBCmCE;AAwVN;ADzXI;EACE,gCAAA;AC2XN;ADxlBE;EAoOI;IACE,iNAAA;ECuXN;AACF;AA1VE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;ED5CA,WC+CE;AA0VN;ADvYI;EACE,wBAAA;ACyYN;AAnWE;EDzCE,kBC+CE;AAgWN;AD7YI;EACE,+BAAA;AC+YN;AD5mBE;EAoOI;IACE,yMAAA;EC2YN;ED5YI;IACE,gNAAA;EC8YN;AACF;AApWE;EACE,gBAAA;EDvDA,YC0DE;AAoWN;AD5ZI;EACE,yBAAA;AC8ZN;AD3nBE;EAoOI;IACE,8MAAA;EC0ZN;AACF;AAtWE;EACE,aAAA;EACA,mBAAA;AAwWJ;AAtWI;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AAwWN;AArWI;EACE,gBAAA;AAuWN;AApWI;EACE,eAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AAsWN;;AAjWA;;EAEE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAoWF;;AA/VE;;EACE,WAAA;EACA,kBAAA;ED7IF,mBC+IiD;AAkWnD;AD9eE;;EACE,gCARmB;ACyfvB;ADzqBE;EAuLA;;IAII,kJAAA;ECmfJ;AACF;AAzWE;;EDlJA,mBCmJiD;AA4WnD;AD5fE;;EACE,gCARmB;ACugBvB;ADvrBE;EAuLA;;IAII,kJAAA;ECigBJ;AACF;AAnXE;;EDhHE,YCkHE;AAqXN;ADreI;;EACE,yBAAA;ACweN;ADrsBE;EAoOI;;IACE,8MAAA;ECqeN;AACF;AA1XI;;EACE,mBAAA;AA6XN;;AAxXA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;EDrIE,kBCwIA;AAyXJ;AD/fI;EACE,+BAAA;ACigBN;AAvYA;ED7HI,mBCwIA;AA+XJ;ADrgBI;EACE,gCAAA;ACugBN;AA7YA;ED7HI,oBCwIA;AAqYJ;AD3gBI;EACE,iCAAA;AC6gBN;AAnZA;ED7HI,iBCwIA;AA2YJ;ADjhBI;EACE,8BAAA;ACmhBN;ADhvBE;EAoOI;IACE,gNAAA;EC+gBN;EDhhBI;IACE,iNAAA;ECkhBN;EDnhBI;IACE,kNAAA;ECqhBN;EDthBI;IACE,+MAAA;ECwhBN;AACF;;AAlZE;EACE,WAAA;EACA,kBAAA;EDpJA,mBCsJE;AAoZN;ADxiBI;EACE,gCAAA;AC0iBN;ADvwBE;EAoOI;IACE,iNAAA;ECsiBN;AACF;AAtZE;EACE,WAAA;ED7JA,mBC+JE;AAuZN;ADpjBI;EACE,gCAAA;ACsjBN;AA7ZE;ED5JE,YC+JE;AA6ZN;AD1jBI;EACE,yBAAA;AC4jBN;AAnaE;ED5JE,gBC+JE;AAmaN;ADhkBI;EACE,6BAAA;ACkkBN;AD/xBE;EAoOI;IACE,iNAAA;EC8jBN;ED/jBI;IACE,0MAAA;ECikBN;EDlkBI;IACE,8MAAA;ECokBN;AACF;AAzaE;EACE,cFxVoB;AEmwBxB;AAxaE;ED3KE,YC6KE;AAyaN;ADplBI;EACE,yBAAA;ACslBN;ADnzBE;EAoOI;IACE,8MAAA;ECklBN;AACF;AA5aI;EACE,mBAAA;EACA,gBAAA;AA8aN","sourcesContent":["@use 'sass:math';\n\n$transition-base: all 0.15s ease;\n$network-log-width: 450px;\n$header-height: 150px;\n$page-padding: 88px;\n\n/* #region Responsive Framework */\n\n$breakpoint-sm: 880px;\n$breakpoint-ms: 1000px;\n$breakpoint-md: 1260px;\n$breakpoint-lg: 1320px;\n$breakpoint-xl: 1920px;\n$breakpoint-xxl: 1921px;\n// max for portrait collection\n$breakpoint-maxP: 2875px;\n// max for landscape collection\n$breakpoint-maxL: 3421px;\n\n$min-ratio-base: 0.65;\n\n/* #endregion */\n\n$dialog-max-width: $breakpoint-xl;\n$dialog-max-height: 1080px;\n$dialog-min-width: $breakpoint-sm;\n$dialog-sidebar-width: 695px;\n$dialog-sidebar-min-width: 250px;\n\n$player-sheet-width: 695px;\n\n/* #region Content Items */\n\n$media-item-min-ratio: 0.85;\n$media-item-max-ratio: 1.75;\n\n$portrait-width: 257px;\n$portrait-height: 367px;\n$portrait-ratio: math.div($portrait-height, $portrait-width) * 100%;\n$portrait-width-min: calc($portrait-width * $media-item-min-ratio);\n$portrait-width-max: calc($portrait-width * $media-item-max-ratio);\n\n$landscape-width: 406px;\n$landscape-height: 229px;\n$landscape-ratio: math.div($landscape-height, $landscape-width) * 100%;\n$landscape-width-min: calc($landscape-width * $media-item-min-ratio);\n$landscape-width-max: calc($landscape-width * $media-item-max-ratio);\n\n$wide-landscape-width: 554px;\n$wide-landscape-height: 214px;\n$wide-landscape-ratio: math.div($wide-landscape-height, $wide-landscape-width) * 100%;\n$wide-landscape-width-min: calc($wide-landscape-width * $media-item-min-ratio);\n$wide-landscape-width-max: calc($wide-landscape-width * $media-item-max-ratio);\n\n$provider-box-width: 257px;\n$provider-box-height: 168px;\n$provider-box-ratio: math.div($provider-box-height, $provider-box-width) * 100%;\n$provider-box-width-min: calc($provider-box-width * $media-item-min-ratio);\n$provider-box-width-max: calc($provider-box-width * $media-item-max-ratio);\n\n$content-item-logo-width: 50px;\n$content-item-logo-height: 32px;\n$content-item-logo-ratio: math.div($content-item-logo-height, $content-item-logo-width) * 100%;\n$content-item-logo-width-min: calc($content-item-logo-width * $media-item-min-ratio);\n$content-item-logo-width-max: calc($content-item-logo-width * $media-item-max-ratio);\n\n$back-icon-button-position: 12px;\n\n/* #endregion */\n\n/* #region Color Palette */\n\n// Shades\n$color-shades-secondary-20: #1f2b37;\n\n// Tints\n$color-tint-60: #011224;\n$color-tint-primary-10: #1a2a3a;\n$color-tint-primary-60: #99a0a7;\n$color-tint-secondary-10: #3d4a58;\n\n// Palette: Background\n$color-background-default: #252525;\n$color-background-primary: #011224;\n$color-background-secondary: #273645;\n$color-background-tertiary: #414d5b;\n$color-background-level1: #303030;\n$color-background-level2: #ccc;\n\n// Palette: Divider & Common\n$color-divider: #9e9e9e;\n$color-white: #f2f2f2;\n$color-black: #000;\n\n// Palette: Error\n$color-error-main: #f44336;\n$color-error-dark: #d32f2f;\n$color-error-secondary: #ffdb38;\n$color-error-contrast-text: #f2f2f2;\n\n// Palette: Grey\n$color-grey-light: #9b9b9b;\n$color-grey-main: #505050;\n$color-grey-dark: #303030;\n\n// Palette: Primary\n$color-primary-main: #369993;\n$color-primary-dark: #00c9a2;\n$color-primary-contrast-text: #000;\n\n// Palette: Secondary\n$color-secondary-main: #755ffa;\n$color-secondary-dark: #8370f1;\n$color-secondary-contrast-text: #000;\n\n// Palette: Tertiary\n$color-tertiary-main: rgba(65, 77, 91, 0.8);\n\n// Palette: Royal Blue\n$color-royalblue-main: #002b6b;\n$color-royalblue-dark: #3f82cf;\n\n// Palette: Light Purple\n$color-lightpurple-main: #e3e1ff;\n$color-lightpurple-dark: #e3e1ff;\n\n// Palette: Red\n$color-red-main: #f8232d;\n$color-red-dark: #f84049;\n\n// Palette: Success\n$color-success-main: #00c9a2;\n$color-success-light: #369993;\n\n// Palette: Text\n$color-text-primary: #f2f2f2;\n$color-text-primary-hover: #f2f2f2;\n$color-text-secondary: #9b9b9b;\n$color-text-secondary-hover: #f2f2f2;\n$color-text-dark: #011224;\n$color-text-tint-60: #93999f;\n\n// space indicators\n$color-space-indicator-recorded: #2ed28b;\n$color-space-indicator-scheduled: #3f82cf;\n$color-space-indicator-free: #f5f5ed;\n\n//#endregion\n\n/* #region Border Radius */\n\n$border-radius-sm: 4px;\n$border-radius-md: 8px;\n$border-radius-lg: 12px;\n\n/* #endregion */\n\n/* #region Typography */\n\n// Typography: Font Family\n$font-family: 'Norlys', sans-serif;\n$font-family-headline: 'Norlys Headline', sans-serif;\n\n// Typography: Weight\n$font-weight-light: 300;\n$font-weight-regular: 400;\n$font-weight-medium: 500;\n$font-weight-bold: 700;\n\n// min values are used for fluid typography, to ensure that the font size does not go below\n// a certain threshold on smaller screens. typically, the min value is set to half of the\n// max value, but it can be adjusted as needed.\n\n$typography-min-ratio: 0.85;\n\n// Typography: h1-h6, body, caption, button\n$h1-font-family: $font-family-headline;\n$h1-font-size: 88px;\n$h1-font-size-min: calc($h1-font-size * $typography-min-ratio);\n$h1-line-height: 1.36em; // was: 120px\n$h1-font-weight: $font-weight-bold;\n\n$h2-font-family: $font-family-headline;\n$h2-font-size: 72px;\n$h2-font-size-min: calc($h2-font-size * $typography-min-ratio);\n$h2-line-height: 1.36em; // was: 98px\n$h2-font-weight: $font-weight-bold;\n\n$h3-font-family: $font-family-headline;\n$h3-font-size: 60px;\n$h3-font-size-min: calc($h3-font-size * $typography-min-ratio);\n$h3-line-height: 1.4em; // was: 84px\n$h3-font-weight: $font-weight-regular;\n\n$h4-font-family: $font-family;\n$h4-font-size: 50px;\n$h4-font-size-min: calc($h4-font-size * $typography-min-ratio);\n$h4-line-height: 1.4em; // was: 70px\n$h4-font-weight: $font-weight-bold;\n\n$h5-font-family: $font-family;\n$h5-font-size: 42px;\n$h5-font-size-min: calc($h5-font-size * $typography-min-ratio);\n$h5-line-height: 1.33em; // was: 56px\n$h5-font-weight: $font-weight-regular;\n\n$h6-font-family: $font-family;\n$h6-font-size: 35px;\n$h6-font-size-min: calc($h6-font-size * $typography-min-ratio);\n$h6-line-height: 1.4em; // was: 49px\n$h6-font-weight: $font-weight-bold;\n\n$body-font-family: $font-family;\n$body-font-size: 32px;\n$body-font-size-min: calc($body-font-size * $typography-min-ratio);\n$body-line-height: 1.38em; // was: 44px\n$body-font-weight: $font-weight-regular;\n\n$body-small-font-family: $font-family;\n$body-small-font-size: 28px;\n$body-small-font-size-min: calc($body-small-font-size * $typography-min-ratio);\n$body-small-line-height: 1.39em; // was: 39px\n$body-small-font-weight: $font-weight-regular;\n\n$caption-font-family: $font-family;\n$caption-font-size: 24px;\n$caption-font-size-min: calc($caption-font-size * $typography-min-ratio);\n$caption-line-height: 1.46em; // was: 35px\n$caption-font-weight: $font-weight-bold;\n\n$caption2-font-family: $font-family;\n$caption2-font-size: 22px;\n$caption2-font-size-min: calc($caption2-font-size * $typography-min-ratio);\n$caption2-line-height: 1.27em; // was: 28px\n$caption2-font-weight: $font-weight-regular;\n\n/* #endregion */\n\n/* #region Button */\n$button-font-size: 24px;\n$button-font-size-min: calc($button-font-size * $typography-min-ratio);\n$button-height: 72px;\n$button-height-min: calc($button-height * $min-ratio-base);\n$button-width: 406px;\n$button-width-min: calc($button-width * $min-ratio-base);\n\n$button-sm-font-size: 22px;\n$button-sm-font-size-min: calc($button-sm-font-size * $typography-min-ratio);\n$button-sm-height: 56px;\n$button-sm-height-min: calc($button-sm-height * $min-ratio-base);\n\n$button-header-font-size: 32px;\n$button-header-font-size-min: calc($button-header-font-size * $typography-min-ratio);\n$button-header-height: 80px;\n$button-header-height-min: calc($button-header-height * $min-ratio-base);\n\n$button-icon-size: 40px;\n$button-icon-size-min: calc($button-icon-size * $typography-min-ratio);\n\n/* #endregion */\n\n/* #region Z-Index */\n\n$zindex-player-controls: 1250;\n$zindex-dialog: 1300;\n$zindex-overlay: 1400;\n$zindex-tooltip: 1500;\n\n/* #endregion */\n","@use 'sass:map';\n@use 'sass:math';\n@use 'sass:meta';\n@use '/src/scaffold/styles/variables' as vars;\n\n$spacing-step: 4px;\n\n$browser-scale-constant: 0.65;\n\n$breakpoints: (\n  sm: vars.$breakpoint-sm,\n  ms: vars.$breakpoint-ms,\n  md: vars.$breakpoint-md,\n  lg: vars.$breakpoint-lg,\n  xl: vars.$breakpoint-xl,\n  xxl: vars.$breakpoint-xxl,\n  maxP: vars.$breakpoint-maxP,\n  maxL: vars.$breakpoint-maxL\n);\n\n/*\n  The spacing function is a simple utility that takes a multiplier and returns the corresponding \n  spacing value based on the defined spacing step. This allows for easy adjustments to the overall \n  spacing of the app by simply changing the value of $spacing-step.\n\n  This is made only to mirror the spacing function in the design system.\n\n  - MRA\n*/\n\n@function spacing($multiplier) {\n  @return $spacing-step * $multiplier;\n}\n\n/*\n  The breakpoint mixins are utilities for handling responsive design. They allow you to write media queries \n  in a more readable and maintainable way by using named breakpoints defined in the $breakpoints map.\n\n  - MRA\n*/\n\n@function breakpoint($name) {\n  @if map.has-key($breakpoints, $name) {\n    @return map.get($breakpoints, $name);\n  }\n\n  @error 'Unknown breakpoint `#{$name}`. Available: #{map.keys($breakpoints)}';\n}\n\n@mixin respond-up($name) {\n  @media (min-width: breakpoint($name)) {\n    @content;\n  }\n}\n\n@mixin respond-down($name) {\n  @media (max-width: #{breakpoint($name) - 1px}) {\n    @content;\n  }\n}\n\n@mixin respond-between($min-name, $max-name) {\n  @media (min-width: breakpoint($min-name)) and (max-width: #{breakpoint($max-name) - 1px}) {\n    @content;\n  }\n}\n\n/*\n  Experimental\n\n  There are now two distinct fluid helpers in this file:\n\n  1. `fluid-props($map, $breakpoint)`\n     Keeps the existing behavior for a group of properties.\n     Static values are emitted first, and inside `respond-down($breakpoint)`\n     each property scales from the provided value down toward the `sm`\n     breakpoint using the original proportional logic.\n\n  2. `fluid-prop-range(...)`\n     Handles a single property with three explicit values:\n     - a base value, emitted outside any media query\n     - a min value, used for scaling down from `xl` to `sm`\n     - a max value, used for scaling up from `xxl` and above\n\n     The downscale path is a direct interpolation between the explicit\n     min and base values. The upscale path reuses the same proportional\n     viewport logic as the original helper, anchored to the base value,\n     and clamps the result so it never exceeds the explicit max value.\n\n  - MRA\n*/\n\n/*\n  Builds a clamp() expression from two explicit values and two explicit\n  breakpoints.\n\n  This is the low-level interpolation helper used when both endpoints are\n  known, for example when a property should be exactly 24px at `sm` and\n  exactly 40px at `xl`.\n*/\n\n@function fluid-between($min-value, $max-value, $min-breakpoint, $max-breakpoint) {\n  @if meta.type-of($min-value) != 'number' or meta.type-of($max-value) != 'number' {\n    $breakpoint-range: $max-breakpoint - $min-breakpoint;\n\n    @if $breakpoint-range <= 0px {\n      @error 'fluid-between requires max breakpoint to be larger than min breakpoint.';\n    }\n\n    @return clamp(\n      #{$min-value},\n      calc(#{$min-value} + (#{$max-value} - #{$min-value}) * ((100vw - #{$min-breakpoint}) / #{$breakpoint-range})),\n      #{$max-value}\n    );\n  }\n\n  $min-val-num: math.div($min-value, 1px);\n  $max-val-num: math.div($max-value, 1px);\n  $min-break-num: math.div($min-breakpoint, 1px);\n  $max-break-num: math.div($max-breakpoint, 1px);\n\n  @if $min-break-num >= $max-break-num {\n    @error 'fluid-between requires min breakpoint to be smaller than max breakpoint.';\n  }\n\n  $slope: math.div($max-val-num - $min-val-num, $max-break-num - $min-break-num);\n  $intercept: $min-val-num - ($slope * $min-break-num);\n  $clamp-min: math.min($min-val-num, $max-val-num);\n  $clamp-max: math.max($min-val-num, $max-val-num);\n\n  @return clamp(#{$clamp-min}px, calc(#{$intercept}px + #{$slope * 100}vw), #{$clamp-max}px);\n}\n\n/*\n  Recreates the original proportional scaling logic used by `fluid-prop`.\n\n  Only the upper value is supplied. The lower value is derived from the\n  ratio between the provided maximum value and its controlling breakpoint,\n  then passed through `fluid-between()` for the final clamp() expression.\n*/\n\n@function fluid-value($max-value, $min-breakpoint, $max-breakpoint) {\n  @if meta.type-of($max-value) != 'number' {\n    $ratio: math.div($min-breakpoint, $max-breakpoint);\n    $min-value: calc(#{$max-value} * #{$ratio});\n\n    @return fluid-between($min-value, $max-value, $min-breakpoint, $max-breakpoint);\n  }\n\n  $max-val-num: math.div($max-value, 1px);\n  $min-break-num: math.div($min-breakpoint, 1px);\n  $max-break-num: math.div($max-breakpoint, 1px);\n\n  @if $min-break-num >= $max-break-num {\n    @error 'fluid-value requires min breakpoint to be smaller than max breakpoint.';\n  }\n\n  $ratio: math.div($max-val-num, $max-break-num);\n  $min-value: $min-break-num * $ratio;\n\n  @return fluid-between($min-value * 1px, $max-value, $min-breakpoint, $max-breakpoint);\n}\n\n/*\n  Scales upward from a base value using the same proportional viewport logic\n  as the original helper, then clamps that growth to an explicit max value.\n\n  The ratio is anchored to the base value and its reference breakpoint.\n  In practice this means the property keeps its base value until the viewport\n  is large enough for the preferred fluid expression to exceed it, after which\n  it grows smoothly until the explicit max value is reached.\n*/\n\n@function fluid-max-value($base-value, $max-value, $base-breakpoint) {\n  @if meta.type-of($base-value) != 'number' or meta.type-of($max-value) != 'number' {\n    @return clamp(\n      #{$base-value},\n      calc((#{$base-value} / #{$base-breakpoint}) * 100vw),\n      #{$max-value}\n    );\n  }\n\n  $base-val-num: math.div($base-value, 1px);\n  $max-val-num: math.div($max-value, 1px);\n  $base-break-num: math.div($base-breakpoint, 1px);\n\n  @if $base-break-num <= 0 {\n    @error 'fluid-max-value requires a breakpoint larger than 0.';\n  }\n\n  @if $base-val-num > $max-val-num {\n    @error 'fluid-max-value requires max value to be greater than or equal to base value.';\n  }\n\n  $ratio: math.div($base-val-num, $base-break-num);\n\n  @return clamp(#{$base-val-num}px, calc(#{$ratio * 100}vw), #{$max-val-num}px);\n}\n\n@function fluid-prop($max-value, $min-name: sm, $max-name: xl) {\n  @return fluid-value($max-value, breakpoint($min-name), breakpoint($max-name));\n}\n\n/*\n  Single-property helper for the three-value case.\n\n  Output behavior:\n  - Base value is emitted directly, outside any media query.\n  - Inside `respond-down($base-name)`, the property scales from the explicit\n    min value up to the base value.\n  - If `$max-value` is provided, inside `respond-up($max-name)` the property\n    scales upward from the base value and is clamped so it never exceeds the\n    explicit max value.\n  - If `$max-value` is omitted (or `null`), no upscale media query is emitted.\n\n  Example:\n  @include utils.fluid-prop-range(font-size, 40px, 24px, 56px);\n\n  Example without max:\n  @include utils.fluid-prop-range(font-size, 40px, 24px);\n*/\n\n@mixin fluid-prop-range(\n  $prop,\n  $base-value,\n  $min-value,\n  $max-value: null,\n  $min-name: sm,\n  $base-name: xl,\n  $max-name: xxl\n) {\n\n  $browser-base-value: calc(#{ $base-value} * $browser-scale-constant);\n  $browser-min-value: calc(#{ $min-value} * $browser-scale-constant);\n  $browser-max-value: calc(#{ $max-value} * $browser-scale-constant);\n\n  #{$prop}: $base-value;\n\n  // Responsive functionality is now isolated to browser-mode\n  :global(.browser-mode) & {\n    #{$prop}: $browser-base-value;\n  \n    @include respond-down($base-name) {\n      #{$prop}: fluid-between($browser-min-value, $browser-base-value, breakpoint($min-name), breakpoint($base-name));\n    }\n\n    @if $max-value != null {\n      @include respond-up($max-name) {\n        #{$prop}: fluid-max-value($browser-base-value, $browser-max-value, breakpoint($base-name));\n      }\n    }\n  }\n}\n\n/*\n  Group-property helper for the original xl-to-sm scaling case.\n\n  Output behavior:\n  - Each property in the map is emitted first as a static base value,\n    outside any media query.\n  - Inside `respond-down($breakpoint)`, every property in the map is\n    recalculated with the original proportional fluid logic so it scales\n    down toward the `sm` breakpoint.\n\n  This helper is intended for the existing multi-property scenario where a\n  component has one shared upper breakpoint and each property should shrink\n  proportionally beneath it.\n\n  Examples:\n  @include utils.fluid-props((margin-top: 64px, margin-left: 52px));\n  @include utils.fluid-props((margin-top: 64px), $breakpoint: lg);\n*/\n@mixin fluid-props($map, $breakpoint: xl) {\n  @each $prop, $val in $map {\n    #{$prop}: $val;\n\n    :global(.browser-mode) & {\n      #{$prop}: calc(#{ $val} * $browser-scale-constant);\n    }\n  }\n\n\n  @include respond-down($breakpoint) {\n    @each $prop, $val in $map {\n      :global(.browser-mode) & {\n        #{$prop}: fluid-prop(calc(#{ $val} * $browser-scale-constant), sm, $breakpoint);\n      }\n    }\n  }\n}\n\n// END experimental\n","@use '/src/scaffold/styles/utilities' as utils;\n@use '/src/scaffold/styles/variables' as vars;\n\n.favorites {\n  display: flex;\n  height: 100vh;\n\n  :global(.browser-mode) & {\n    max-width: vars.$breakpoint-xl;\n    min-width: vars.$breakpoint-sm;\n  }\n\n  @include utils.fluid-props(\n    (\n      padding-top: 122px,\n      padding-left: vars.$page-padding,\n      padding-right: vars.$page-padding,\n      padding-bottom: vars.$page-padding\n    )\n  );\n\n  :not(:global(.browser-mode)) & {\n    padding-bottom: 0;\n  }\n}\n\n.favorites-dialog-container {\n  overflow: auto;\n}\n\n.favorites-home-layout {\n  flex-shrink: 0;\n  @include utils.fluid-props(\n    (\n      width: 580px,\n      margin-right: vars.$page-padding\n    )\n  );\n}\n\n.favorites-home-root {\n  &--title {\n    width: 100%;\n    overflow-wrap: break-word;\n    @include utils.fluid-prop-range(margin-bottom, 32px, calc(32px * vars.$min-ratio-base));\n  }\n\n  &--list {\n    @include utils.fluid-prop-range(height, 550px, calc(550px * vars.$min-ratio-base));\n  }\n\n  &--row {\n    display: flex;\n    flex-direction: row;\n  }\n\n  &--item {\n    @include utils.fluid-props(\n      (\n        width: 379px\n      )\n    );\n    flex: none;\n  }\n\n  &--actions {\n    display: flex;\n    flex-direction: row;\n\n    .favorites-home-root--btn-wrap {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      overflow: visible;\n\n      @include utils.fluid-prop-range(margin-left, 32px, calc(32px * vars.$min-ratio-base));\n      @include utils.fluid-prop-range(width, vars.$button-height, vars.$button-height-min);\n      @include utils.fluid-prop-range(height, vars.$button-height, vars.$button-height-min);\n    }\n\n    .favorites-home-root--btn {\n      padding: 0;\n\n      @include utils.fluid-prop-range(min-width, vars.$button-height, vars.$button-height-min);\n      @include utils.fluid-prop-range(min-height, vars.$button-height, vars.$button-height-min);\n      @include utils.fluid-prop-range(margin-bottom, 4px, calc(4px * vars.$min-ratio-base));\n    }\n\n    .favorites-home-root--btn-label {\n      display: block;\n      width: max-content;\n      margin-left: auto;\n      margin-right: auto;\n      text-align: center;\n    }\n  }\n\n  &--create {\n    margin-top: 24px;\n    max-width: 456px;\n    width: 100%;\n  }\n\n  &--create-btn,\n  &--back-btn {\n    max-width: 406px;\n    width: 100%;\n  }\n\n  &--back-btn {\n    margin-top: 24px;\n  }\n}\n\n.favorites-home-channels-layout {\n  min-width: 0;\n  @include utils.fluid-props(\n    (\n      max-width: 1132px\n    )\n  );\n}\n\n.favorites-home-channels-root {\n  &--image {\n    @include utils.fluid-prop-range(width, 100px, calc(100px * vars.$media-item-min-ratio));\n    @include utils.fluid-prop-range(height, 65px, calc(65px * vars.$media-item-min-ratio));\n    border-radius: vars.$border-radius-sm;\n    @include utils.fluid-prop-range(margin-bottom, 16px, calc(16px * vars.$media-item-min-ratio));\n    @include utils.fluid-prop-range(margin-right, 16px, calc(16px * vars.$media-item-min-ratio));\n  }\n\n  &--desc {\n    font-weight: bold;\n    margin-top: 16px;\n  }\n}\n\n/**/\n.favorites-edit-layout {\n  width: 100%;\n\n  &--hidden {\n    visibility: hidden;\n    width: 0;\n    overflow: hidden;\n  }\n}\n\n.favorites-edit-root {\n  &--content {\n    display: grid;\n    grid-template-columns: max-content minmax(0, max-content) auto;\n    grid-template-rows: auto minmax(0, 1fr);\n    height: calc(100% - 84px);\n    align-items: flex-start;\n    padding-top: 40px;\n  }\n\n  &--logo {\n    border-radius: vars.$border-radius-sm;\n\n    @include utils.fluid-prop-range(height, 49px, calc(49px * vars.$media-item-min-ratio));\n    @include utils.fluid-prop-range(width, 75px, calc(75px * vars.$media-item-min-ratio));\n\n    @include utils.fluid-props(\n      (\n        border-radius: vars.$border-radius-sm,\n        margin-right: 16px\n      )\n    );\n  }\n\n  &--channels-tv {\n    overflow: hidden;\n    grid-column: 1;\n    grid-row: 2;\n    height: 100%;\n    @include utils.fluid-props(\n      (\n        width: 520px,\n        margin-right: 122px\n      )\n    );\n  }\n\n  &--channels-browser {\n    overflow: hidden;\n    grid-column: 1;\n    grid-row: 2;\n    @include utils.fluid-props(\n      (\n        width: 520px,\n        margin-right: 122px\n      )\n    );\n  }\n\n  &--menu {\n    overflow: hidden;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    grid-column: 3;\n    grid-row: 2;\n    margin-left: auto;\n\n    @include utils.fluid-props(\n      (\n        margin-top: 125px\n      )\n    );\n  }\n\n  &--menu-btn {\n    @include utils.fluid-props(\n      (\n        width: 188px,\n        border-radius: 28px\n      )\n    );\n\n    &:not(:last-of-type) {\n      @include utils.fluid-props(\n        (\n          margin-bottom: 32px\n        )\n      );\n    }\n  }\n\n  &--empty {\n    display: flex;\n    flex-direction: column;\n    grid-column: 2;\n    grid-row: 1 / span 2;\n    margin-top: 40px;\n  }\n\n  &--empty-title {\n    @include utils.fluid-props(\n      (\n        margin-left: 64px,\n        margin-bottom: 16px\n      )\n    );\n  }\n\n  &--empty-secondary-title {\n    @include utils.fluid-props(\n      (\n        margin-left: 64px,\n        margin-bottom: 16px\n      )\n    );\n  }\n\n  &--selected {\n    display: contents;\n    min-width: 0;\n  }\n\n  &--selected-header {\n    grid-column: 2;\n    grid-row: 1;\n  }\n\n  &--selected-title {\n    @include utils.fluid-props(\n      (\n        margin-left: 64px,\n        margin-bottom: 44px\n      )\n    );\n  }\n  &--selected-secondary-title {\n    @include utils.fluid-props(\n      (\n        margin-left: 64px\n      )\n    );\n  }\n\n  &--list-tv {\n    overflow: hidden;\n    grid-column: 2;\n    grid-row: 2;\n    padding-bottom: 12px;\n    height: 100%;\n  }\n\n  &--list-browser {\n    grid-column: 2;\n    grid-row: 2;\n    padding-bottom: 12px;\n  }\n\n  &--draggable:not(&--dragging) {\n    border: 4px dashed transparent;\n  }\n\n  &--dragging {\n    border: 4px dashed vars.$color-secondary-dark;\n  }\n\n  &--row {\n    display: flex;\n    flex-direction: row;\n    @include utils.fluid-props(\n      (\n        margin-bottom: 12px\n      )\n    );\n  }\n\n  &--num {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n\n    @include utils.fluid-props(\n      (\n        width: 48px,\n        margin-right: 16px\n      )\n    );\n  }\n\n  &--item {\n    overflow: hidden;\n\n    @include utils.fluid-props(\n      (\n        width: 520px\n      )\n    );\n  }\n\n  &--order {\n    display: flex;\n    flex-direction: row;\n\n    .favorites-edit-root--order-btn-wrap {\n      margin-left: 24px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      overflow: visible;\n      width: 90px;\n      height: 72px;\n    }\n\n    .favorites-edit-root--order-btn-wrap-right {\n      margin-left: 8px;\n    }\n\n    .favorites-edit-root--order-btn {\n      min-width: 72px;\n      min-height: 72px;\n      padding: 0;\n      margin-bottom: 4px;\n    }\n  }\n}\n\n.favorites-save-layout,\n.favorites-delete-layout {\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.favorites-save-root,\n.favorites-delete-root {\n  &--title {\n    width: 100%;\n    text-align: center;\n\n    @include utils.fluid-prop-range(margin-bottom, 40px, calc(40px * vars.$min-ratio-base));\n  }\n\n  &--name {\n    @include utils.fluid-prop-range(margin-bottom, 80px, calc(80px * vars.$min-ratio-base));\n  }\n\n  &--button {\n    @include utils.fluid-props(\n      (\n        width: 406px\n      )\n    );\n\n    &:not(:last-of-type) {\n      margin-bottom: 32px;\n    }\n  }\n}\n\n.favorites-title-layout {\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 675px;\n  width: 100%;\n  box-sizing: content-box;\n\n  @include utils.fluid-props(\n    (\n      padding-left: vars.$page-padding,\n      padding-right: vars.$page-padding,\n      padding-bottom: vars.$page-padding,\n      padding-top: vars.$page-padding,\n    )\n  );\n}\n\n.favorites-title-root {\n  &--header {\n    width: 100%;\n    text-align: center;\n    @include utils.fluid-props(\n      (\n        margin-bottom: 48px\n      )\n    );\n  }\n\n  &--input {\n    width: 100%;\n    @include utils.fluid-props(\n      (\n        margin-bottom: 40px,\n        height: 68px,\n        min-height: 68px\n      )\n    );\n  }\n\n  &--error {\n    color: vars.$color-error-secondary;\n  }\n\n  &--button {\n    @include utils.fluid-props(\n      (\n        width: 406px\n      )\n    );\n\n    &:not(:last-of-type) {\n      margin-bottom: 32px;\n      margin-top: 40px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"favorites": `favorites__m536v`,
	"favorites-dialog-container": `favorites-dialog-container__HtLjF`,
	"favorites-home-layout": `favorites-home-layout__Lk0Dc`,
	"favorites-home-root--title": `favorites-home-root--title__AHYpy`,
	"favorites-home-root--list": `favorites-home-root--list__cCN8R`,
	"favorites-home-root--row": `favorites-home-root--row__DDeMS`,
	"favorites-home-root--item": `favorites-home-root--item__kHNK6`,
	"favorites-home-root--actions": `favorites-home-root--actions__KQ5bC`,
	"favorites-home-root--btn-wrap": `favorites-home-root--btn-wrap__XLvf5`,
	"favorites-home-root--btn": `favorites-home-root--btn__f6FAx`,
	"favorites-home-root--btn-label": `favorites-home-root--btn-label__n5Tqm`,
	"favorites-home-root--create": `favorites-home-root--create__cBiNL`,
	"favorites-home-root--create-btn": `favorites-home-root--create-btn__Gs8OX`,
	"favorites-home-root--back-btn": `favorites-home-root--back-btn__NPeXk`,
	"favorites-home-channels-layout": `favorites-home-channels-layout__eKqzO`,
	"favorites-home-channels-root--image": `favorites-home-channels-root--image__WPsaU`,
	"favorites-home-channels-root--desc": `favorites-home-channels-root--desc__ubj9f`,
	"favorites-edit-layout": `favorites-edit-layout__c_75X`,
	"favorites-edit-layout--hidden": `favorites-edit-layout--hidden__qO45A`,
	"favorites-edit-root--content": `favorites-edit-root--content__ANPhS`,
	"favorites-edit-root--logo": `favorites-edit-root--logo__L_2u6`,
	"favorites-edit-root--channels-tv": `favorites-edit-root--channels-tv__Q81Oj`,
	"favorites-edit-root--channels-browser": `favorites-edit-root--channels-browser__x0vSY`,
	"favorites-edit-root--menu": `favorites-edit-root--menu__hrerk`,
	"favorites-edit-root--menu-btn": `favorites-edit-root--menu-btn__Lvg76`,
	"favorites-edit-root--empty": `favorites-edit-root--empty__UXrOI`,
	"favorites-edit-root--empty-title": `favorites-edit-root--empty-title__b27_E`,
	"favorites-edit-root--empty-secondary-title": `favorites-edit-root--empty-secondary-title__wv9nc`,
	"favorites-edit-root--selected": `favorites-edit-root--selected__CVO4v`,
	"favorites-edit-root--selected-header": `favorites-edit-root--selected-header__eVuyy`,
	"favorites-edit-root--selected-title": `favorites-edit-root--selected-title__lrale`,
	"favorites-edit-root--selected-secondary-title": `favorites-edit-root--selected-secondary-title__UUHRw`,
	"favorites-edit-root--list-tv": `favorites-edit-root--list-tv__DoIXH`,
	"favorites-edit-root--list-browser": `favorites-edit-root--list-browser__YSRAH`,
	"favorites-edit-root--draggable": `favorites-edit-root--draggable__BVswv`,
	"favorites-edit-root--dragging": `favorites-edit-root--dragging__TERH1`,
	"favorites-edit-root--row": `favorites-edit-root--row__WTF4l`,
	"favorites-edit-root--num": `favorites-edit-root--num__iYtea`,
	"favorites-edit-root--item": `favorites-edit-root--item__OPnqT`,
	"favorites-edit-root--order": `favorites-edit-root--order__luVYP`,
	"favorites-edit-root--order-btn-wrap": `favorites-edit-root--order-btn-wrap__kpdQG`,
	"favorites-edit-root--order-btn-wrap-right": `favorites-edit-root--order-btn-wrap-right__hy27I`,
	"favorites-edit-root--order-btn": `favorites-edit-root--order-btn__ZO6eU`,
	"favorites-save-layout": `favorites-save-layout__sAQwt`,
	"favorites-delete-layout": `favorites-delete-layout__WgyTL`,
	"favorites-save-root--title": `favorites-save-root--title__KMesw`,
	"favorites-delete-root--title": `favorites-delete-root--title__G9IEq`,
	"favorites-save-root--name": `favorites-save-root--name__uBSpI`,
	"favorites-delete-root--name": `favorites-delete-root--name__LyfZu`,
	"favorites-save-root--button": `favorites-save-root--button__UotRl`,
	"favorites-delete-root--button": `favorites-delete-root--button__K4WAY`,
	"favorites-title-layout": `favorites-title-layout__SQUW7`,
	"favorites-title-root--header": `favorites-title-root--header__AJaIh`,
	"favorites-title-root--input": `favorites-title-root--input__Y9V9u`,
	"favorites-title-root--error": `favorites-title-root--error__TBhfz`,
	"favorites-title-root--button": `favorites-title-root--button__KSFLT`
};
export default ___CSS_LOADER_EXPORT___;
